export const SORT_ASC = 'asc';
export const SORT_DESC = 'desc';
export const SORT_DEFAULT = 'travelrank';
